export const WORKSPACE_ROUTES = {
  HOME: "/",
  HOME_TODO: "/home",
  DEDUCTIONS: "/deductions",
  APPROVALS: "/approvals",
  INTELLI_UPLOAD: "/intelliUpload",
  CONTRIBUTIONS: "/contributions",
  CONVERSATIONS: "/conversations",
  ANALYTICS: "/analytics",
  USERS: "/users",
  PURGE_DATA: "/purge-data",
  ACCOUNTING: "/accounting",
  TRADE_PROMOTIONS: "/trade-promotions",
  DISPUTES_TRACKING: "/disputes-tracking",
  DOCUMENT_REPOSITORY: "/document-repository",
} as const;
